<template>
    <div class="content-wrapper content-wrapper--maintenance">
        <div class="img-desktop img-desktop-oops d-none d-lg-inline-block"></div>

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2 alert-container"></div>
            </div>
        </section>

        <section class="content content-header">
            <div class="container-fluid">
                <div class="col-sm-10 col-md-8 col-xl-8 facturation-alert">
                    Nous sommes en train de mettre à jour notre produit. Cela peut prendre quelques minutes.
                    Nous vous remercions de votre patience. Veuillez cliquer sur le bouton ci-dessous pour
                    recharger la page. Si le déploiement est terminé vous serez redirigés vers la page de connexion.
                    Vous pouvez également fermer cette page et retourner sur le site dans quelques minutes.
                </div>
            </div>
            <div class="input-group col-md-10 mx-sm-auto my-md-4 mt-4">
                <div class="mx-sm-auto button-box">
                    <button
                        @click="handleCheckApiMode"
                        class="btn btn-success btn-lg ml-4 btn-link btn__save"
                    >
                        <span>Vérifier si le déploiement est terminé</span>
                    </button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { fetchDueLegalInformation } from "@/service/api/dues.api";

export default {
    name: 'MaintenanceMode',
    methods: {
        async handleCheckApiMode() {
            let { data } = await fetchDueLegalInformation();

            if (data) {
                await this.$router.push({ name: 'login' });
            }
        }
    }
}
</script>
